module.exports = __webpack_public_path__ + "static/img/n9m2.67beebc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/n9m/n9m2.jpg
// module id = V13R
// module chunks = 1